// Imports => Constants
import { ENDPOINTS } from '@constants';

export class CategoriesAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  list() {
    return this.Client.get(ENDPOINTS.CATEGORIES.INDEX)
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching categories:', error);
        throw error;
      });
  }
}

export default CategoriesAPI;
